import React from "react";
import "./tcp.scss";
import Navbar from "../../components/Navbar/navbar";
import Footer from "../../components/Footer/footer";

const TermsAndConditions = () => {
const serviceDetails = [
  "Harass, bully, or threaten other users",
  "Post, share, or transmit hate speech, illegal, or explicit content",
  "Impersonate others or misrepresent affiliation with any person or entity",
  "Attempt to hack, disrupt, or misuse the Platform",
];
  return (
    <>
    <Navbar />
    <div className="termsAndConditions fadeIn">
      <h1 className="termsAndConditionsHeading">Terms Of Service</h1>
      <h4 className="spangleWelcome">Welcome to Orter</h4>

      <p className="termsParagraphIntro">
        <strong>Effective Date: </strong>October 2025<br/><br/>
        These Terms & Conditions (“Terms”) govern your use of Orter (“we,” “us,” “our,” or “the Platform”).
        <br />By accessing or using Orter, you agree to these Terms. Please read them carefully.
      </p>

      {/* Section 1 */}
      <div className="serviceLeadingSection">
        <h4>
          <span className="sn blue">1.</span>
          <span className="st blue">Eligibility</span>
        </h4>
        {[...Array(1)].map((_, i) => (
          <div className="serviceInfoContainer" key={i}>
            <p className="serviceDetails">
              You must be at least 18 years old to use Orter. By creating an account, you confirm that you meet this age requirement.
            </p>
            <div className="secionLine lineColorBlue"></div>
          </div>
        ))}
      </div>

      {/* Section 2 */}
      <div className="serviceLeadingSection">
        <h4>
          <span className="sn orange">2.</span>
          <span className="st orange">Account Registration</span>
        </h4>
        {[...Array(1)].map((_, i) => (
          <div className="serviceInfoContainer" key={i}>
            <p className="serviceDetails">
                When you sign up, Orter generates a unique anonymous username. You are responsible for maintaining the confidentiality of your login credentials.
            </p>
            <div className="secionLine lineColorOrange"></div>
          </div>
        ))}
      </div>

      {/* Section 3 */}
      <div className="serviceLeadingSection">
        <h4>
          <span className="sn lightGreen">3.</span>
          <span className="st lightGreen">Acceptable Use</span>
        </h4>
        <p className="spl">
          You agree not to:
        </p>

        {serviceDetails.map((detail, i) => (
          <div className="serviceInfoContainer" key={i}>
            <p className="serviceDetails">{detail}</p>
            <div className="secionLine lineColorGreen"></div>
          </div>
        ))}
      </div>

      {/* Section 4 */}
      <div className="serviceLeadingSection">
        <h4>
          <span className="sn purple">4.</span>
          <span className="st purple">User Content</span>
        </h4>

        {[...Array(1)].map((_, i) => (
          <div className="serviceInfoContainer" key={i}>
            <p className="serviceDetails">
              You own your messages and posts but grant Orter a non-exclusive, royalty-free 
              license to display them for operation of the Platform. You are solely responsible for the information you share.
            </p>
            <div className="secionLine lineColorPurple"></div>
          </div>
        ))}
      </div>

      {/* Section 5 */}
      <div className="serviceLeadingSection">
        <h4>
          <span className="sn gold">5.</span>
          <span className="st gold">Disclaimer of Advice</span>
        </h4>

        {[...Array(1)].map((_, i) => (
          <div className="serviceInfoContainer" key={i}>
            <p className="serviceDetails">
              Orter is a platform for open conversation. Any advice, recommendation, or information 
              shared by users including organizational representatives should be taken with caution. 
              <strong>Orter is not responsible for harm or loss resulting from any user interaction or suggestion.</strong>
            </p>
            <div className="secionLine lineColorGold"></div>
          </div>
        ))}
      </div>

      {/* Section 6 */}
      <div className="serviceLeadingSection">
        <h4>
          <span className="sn brown">6.</span>
          <span className="st brown">Limitation of Liability</span>
        </h4>

        {[...Array(1)].map((_, i) => (
          <div className="serviceInfoContainer" key={i}>
            <p className="serviceDetails">
              To the fullest extent permitted by law, Orter is not liable for indirect, 
              incidental, or consequential damages resulting from use of the Platform.
            </p>
            <div className="secionLine lineColorBrown"></div>
          </div>
        ))}
      </div>
      
      {/* Section 7 */}
      <div className="serviceLeadingSection">
        <h4>
          <span className="sn red">7.</span>
          <span className="st red">Termination</span>
        </h4>

        {[...Array(1)].map((_, i) => (
          <div className="serviceInfoContainer" key={i}>
            <p className="serviceDetails">
              We may suspend or terminate access at any time for violations of policy or legal reasons.
            </p>
            <div className="secionLine lineColorRed"></div>
          </div>
        ))}
      </div>

      {/* Section 8 */}
      <div className="serviceLeadingSection">
        <h4>
          <span className="sn pink">8.</span>
          <span className="st pink">Intellectual Property</span>
        </h4>

        {[...Array(1)].map((_, i) => (
          <div className="serviceInfoContainer" key={i}>
            <p className="serviceDetails">
              All trademarks, logos, and platform materials are the property of Orter Co. 
              You may not copy, modify, or redistribute any part of Orter without written consent.
            </p>
            <div className="secionLine lineColorPink"></div>
          </div>
        ))}
      </div>

      {/* Section 9 */}
      <div className="serviceLeadingSection">
        <h4>
          <span className="sn navy">9.</span>
          <span className="st navy">Changes to Terms</span>
        </h4>

        {[...Array(1)].map((_, i) => (
          <div className="serviceInfoContainer" key={i}>
            <p className="serviceDetails">
              We may update these Terms periodically. Continued use of the Platform constitutes acceptance of the latest version.
            </p>
            <div className="secionLine lineColorNavy"></div>
          </div>
        ))}
      </div>
    </div>
    <Footer />
    </>
  );
};

export default TermsAndConditions;
